import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    userNo: "",
    assistantNo: "",
    assistantName: "",
    userUpholdId: "",
    diseaseType: [],
    healthData: {}, // 健康档案数据
    threeFactorsList: [], // 三因
    symptomTree: [], // 症状
    userInfo: {}, // 用户信息
    // 通话状态
    olaState: {
      olaReady: false,    // 是否已准备
      olaBusy: false,     // 是否占线,
      olaDisabled: false, // 是否不允许拨打
      olaStateStr: '',    // 状态显示文案
      olaSuccess: false,  // 是否接通成功
    },
  },
  mutations: {
    SET_USERNO: (state, userNo) => {
      state.userNo = userNo;
    },
    SET_ASSISTANTNO: (state, assistantNo) => {
      state.assistantNo = assistantNo;
    },
    SET_ASSISTANTNAME: (state, assistantName) => {
      state.assistantName = assistantName;
    },
    SET_USETUPHOLDID: (state, userUpholdId) => {
      state.userUpholdId = userUpholdId;
    },
    changeDiseaseType(state, val) {
      state.diseaseType = val;
    },
    // 健康档案数据
    SET_HEALTH_DATA: (state, healthData) => {
      state.healthData = healthData;
    },
    SET_THREE_FACTORS_LIST: (state, threeFactorsList) => {
      state.threeFactorsList = threeFactorsList;
    },
    SET_SYMPTOM_TREE: (state, symptomTree) => {
      state.symptomTree = symptomTree;
    },
    // 用户信息
    SET_USER_INFO: (state, data) => {
      state.userInfo = data;
    },
    // 拨号状态
    SET_OLA_STATE: (state, data) => {
      state.olaState = { ...data, olaDisabled: !data.olaReady || data.olaBusy };
    }
  },
  getters: {
    getDiseaseType(state) {
      return state.diseaseType;
    },
    getDiseaseTypeName: (state) => (key) => {
      if (state.diseaseType && state.diseaseType.length) {
        for (let i = 0; i < state.diseaseType.length; i++) {
          if (state.diseaseType[i].key == key) {
            return state.diseaseType[i].value;
          }
        }
      }
      return "病种待确认";
    },
    getHealthData(state) {
      return state.healthData;
    },
    getThreeFactorsList(state) {
      return state.threeFactorsList;
    },
    // 三阴 分出来
    getThreeFactorsIndependent(state) {
      const factorsData = { factorsOne: [], factorsTwo: [], factorsThree: [] }
      state.threeFactorsList.forEach((item) => {
        if (item.questionType === 0) {
          factorsData.factorsOne.push(item)
        } else if (item.questionType === 1) {
          factorsData.factorsTwo.push(item)
        } else if (item.questionType === 2) {
          factorsData.factorsThree.push(item)
        }
      })
      return factorsData
    },
    // 主诉
    getSymptomTree(state) {
      return state.symptomTree
    },
    getSymptomTreeChildren(state) {
      return state.symptomTree.reduce((pre, cur) => (cur.children.length ? pre.concat(cur.children) : pre), [])
    },
    getLoginRole(state) {
      return state.assistantNo.startsWith('YS') ? '医生' : '医助'
    },
    getUserInfo(state) {
      return state.userInfo
    },
    getOlaState(state) {
      return state.olaState
    }
  },
  actions: {
    setUserNo({ commit }, userNo) {
      commit("SET_USERNO", userNo);
    },
    setAssistantNo({ commit }, assistantNo) {
      commit("SET_ASSISTANTNO", assistantNo);
    },
    setAssistantName({ commit }, assistantName) {
      commit("SET_ASSISTANTNAME", assistantName);
    },
    setUserUpholdId({ commit }, userUpholdId) {
      commit("SET_USETUPHOLDID", userUpholdId);
    },
    setDiseaseType({ commit }, val) {
      commit("changeDiseaseType", val);
    },
    // 健康档案数据
    setHealthData({ commit }, val) {
      commit("SET_HEALTH_DATA", val);
    },
    // 三因
    setThreeFactorsList({ commit }, val) {
      commit("SET_THREE_FACTORS_LIST", val);
    },
    // 主诉症状
    setSymptomTree({ commit }, val) {
      commit("SET_SYMPTOM_TREE", val);
    },
    // 用户信息
    setUserInfo({ commit }, val) {
      commit("SET_USER_INFO", val);
    },
    // 拨打电话信息
    setOlaState({ commit }, val) {
      commit("SET_OLA_STATE", val);
    }
  },
});
